import { render, staticRenderFns } from "./WhySection.vue?vue&type=template&id=6655cc5c&"
import script from "./WhySection.vue?vue&type=script&lang=js&"
export * from "./WhySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports